import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { SPLASH_IMG } from '@assets';
import { useNavigate } from 'react-router';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { LIMITS } from '@constants';
import { useSelector } from 'react-redux';
import { Logo } from '@styles';

const Container = styled.div`
width: 100%;
height: 100vh;
position: relative;
display: flex;
align-items: center;
justify-content: center;
`;

const Shading = styled.div`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000;
opacity: 0.7;
z-index: 1;
`;

const Image = styled.img.attrs({
    alt: 'bg',
    src: SPLASH_IMG,
})`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
object-fit: cover;
`;

const LogoImg = styled(Logo)`
max-width: 134px;
z-index: 2;
position: relative;
`;

const Text = styled.div`
position: absolute;
bottom: 30px;
width: 100%;
z-index: 2;

font-size: 13px;
font-style: normal;
font-weight: 600;
line-height: normal;
text-align: center;
color: #fff;
`;

const Splash = () => {
    const navigate = useNavigate();
    const { splash_ads_active } = useSelector(state => state.app.settings);
    let timer = useRef();

    useEffect(() => {
        timer.current = setTimeout(() => {
            goToNextScreen(splash_ads_active);
        }, LIMITS.SPLASH_SCREEN_TIMEOUT * 1000);

        return () => {
            clearTimeout(timer.current);
        }
        
        // eslint-disable-next-line
    }, [splash_ads_active]);

    const goToNextScreen = (splash_ads_active) => {
        if (splash_ads_active) {
            navigate(PUBLIC_ROUTE.ONBOARDING);
        }
        else {
            navigate(PUBLIC_ROUTE.LOGIN);
        }
    }

    return (
        <Container>
            <LogoImg />
            <Shading />
            <Image />
            <Text>YADANAR GAMING</Text>
        </Container>
    );
}

export default Splash;